module.exports = __webpack_public_path__ + "img/product.8b075f79.png";